import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ErrorResponse } from '../shared/models/general-responses.model';

@Injectable({
  providedIn: 'root'
})
export class AlertMessageService {

  private showError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public _showError$ = this.showError.asObservable();

  currentAlert: BehaviorSubject<ErrorResponse> = new BehaviorSubject<ErrorResponse>({
    title: '',
    message: '',
    type_id: 0,
    type: 'error',
    mode_id: 0,
    mode: 'alerts'
  });
  public _currentAlert$ = this.currentAlert.asObservable();

  constructor() { }

  async changeErrorState(state: boolean) {
    
  }

  updateAlert(alert: ErrorResponse) {
    if(alert.message) {
      this.currentAlert.next({...alert});
    } 
  }
}
